import { render, staticRenderFns } from "./x-address-linkage.vue?vue&type=template&id=302ede8c&scoped=true&"
import script from "./x-address-linkage.vue?vue&type=script&lang=js&"
export * from "./x-address-linkage.vue?vue&type=script&lang=js&"
import style0 from "./x-address-linkage.vue?vue&type=style&index=0&id=302ede8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ede8c",
  null
  
)

export default component.exports